const datos = state => state.datos

export default { datos }